$(function() {
  $('form').on('click', '#enhancement-training-upload-button', event => $('#enhancement_page_content').trigger('click'));
  return $('form').on('change', '#enhancement_page_content', function(event) {
    return $('#enhancement_page_content_input').val($(this).val());
  });
});
  